import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as certificateActions from '../../actions/certificateActions';
import * as submitButtonActions from '../../actions/submit/submitButtonActions';
import Certificates from './Certificates';
import {toastr} from 'react-redux-toastr';
import SubmitButton from '../common/SubmitButton';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';

class CertificatesPage extends React.Component {

    componentDidMount() {
        this.props.actions.loadCertificates();
    }

    onRowClick(id) {
        this.props.actions.dispatchChangingTheCertificate(id);
    }

    onSubmit() {
        this.props.actions.showSubmitButtonSpinner();
        this.props.actions.dispatchUpdateCertificates()
            .then(() => {
                this.props.actions.hideSubmitButtonSpinner();
                toastr.success(this.props.intl.formatMessage(messages.certificatesAdded));
            })
            .catch(err => {
                this.props.actions.hideSubmitButtonSpinner();
                toastr.error(this.props.intl.formatMessage(messages.certificatesUpdateError));
            });
    }

    onFiltering(e) {
        this.props.actions.dispatchFiltering(e.target.value);
    }

    render() {
        return (
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-block">

                            <div className="row">
                                <div className="col-12">
                                    <h1>{this.props.intl.formatMessage(messages.certificates)}</h1>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <input
                                        type="text"
                                        placeholder={this.props.intl.formatMessage(messages.quickSearch)}
                                        className="form-control"
                                        onChange={this.onFiltering.bind(this)}/>
                                </div>
                            </div>
                            <br/>
                            <Certificates
                                certificates={this.props.certificates}
                                selected={this.props.selected}
                                onRowClick={this.onRowClick.bind(this)}/>
                            <hr/>
                            <div className="form-group row">
                                <div className="col-sm-12">
                                    <SubmitButton
                                        isUpdate={true}
                                        onClick={this.onSubmit.bind(this)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        certificates: state.certificates.all,
        selected: state.certificates.selected,
        company: state.user.company
    }
};

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators(
            {
                ...certificateActions,
                ...submitButtonActions
            }
            , dispatch)
    }
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(CertificatesPage));


// WEBPACK FOOTER //
// ./web/src/components/certificates/CertificatesPage.jsx